import { useNavigate } from "react-router";
import { useAppDispatch } from "../../store/hooks";
import { resetModals } from "../../store/slices/modalsSlice";
import ModalWrapper from "./ModalWrapper";

const SubscriptionCTA = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return (
    <ModalWrapper>
      <div className="text-center bg-white rounded-lg px-5 py-4 min-w-[25%]">
        <p className="text-lg mb-4">يجب الإشتراك لإستخدام هذه الخدمة</p>
        <div className="flex justify-around gap-2">
          <button
            className="bg-green-600 text-white rounded-lg px-4 py-2 hover:bg-green-700 transition cursor-pointer"
            onClick={() => {
              // const url = new URL(window.location.href);
              // if (["/dashboard/main", "/dashboard"].includes(url.pathname)) {
              //   const prices = document.getElementById("prices");
              //   if (prices) {
              //     prices.scrollIntoView({ behavior: "smooth" });
              //   }
              //   dispatch(resetModals());
              //   return;
              // }
              navigate("/subscription-plans");
              dispatch(resetModals());
            }}
          >
            إشترك الآن
          </button>
          <button
            className="text-gray-500 rounded-lg px-4 py-2 hover:text-gray-700 transition cursor-pointer"
            onClick={() => {
              dispatch(resetModals());
            }}
          >
            لاحقاً
          </button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default SubscriptionCTA;
